
import { defineComponent, PropType } from 'vue';
import { IOrder } from '@/types/models';
import utils from '@/utils';

export default defineComponent({
  props: {
    orders: {
      type: Object as PropType<IOrder[]>,
      required: true,
    },
  },
  methods: {
    getResourceType(item: IOrder) {
      return utils.getResourceType(item.resourceType);
    },

    getChannel(item: IOrder) {
      return utils.getPayChannel(item.channel);
    },

    getUrl(item: IOrder) {
      return utils.getResourceUrl(item.resourceType, item.resourceId);
    },
  },
});
